<template>
  <div v-if="html" v-html="html"></div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginFooter",
  data() {
    return {
      html: null,
    };
  },
  mounted() {
    this.getFooterData();
    this.getFooterHtml();
  },
  methods: {
    getFooterData() {
      delete axios.defaults.headers.common["Authorization"];
      axios.defaults.params = {};

      axios.get(process.env.VUE_APP_SITE_API + '/ajax/footer-data')
          .then(response => {
            if (response.data) {
              this.addStyle(response.data.stylesUrl);
            }
          })
          .catch(console.error);
    },
    getFooterHtml() {
      delete axios.defaults.headers.common["Authorization"];
      axios.defaults.params = {};

      axios.get(process.env.VUE_APP_SITE_API + '/ajax/footer-html')
          .then(response => {
            if (response.data) {
              this.html = response.data;
            }
          })
          .catch(console.error);
    },
    addStyle(href) {
      let style = document.createElement("link");
      style.setAttribute('href', href);
      style.setAttribute('name', 'footer-styles');
      style.setAttribute('rel', 'stylesheet');
      document.querySelector('head').appendChild(style);
    },
  }
}
</script>

<!--<div v-if="data" class="site-footer">
    <div class="container">
      <section class="site-footer-menu">
        <div v-for="(section, index) in data.menu" :key="index"
             class="site-footer-menu-section"
             :class="{'site-footer-menu-section--with-social': index + 1 === data.menu.length}">

          <div class="site-footer-menu-items">
            <div v-for="item in section.items" :key="item.url"
                 class="site-footer-menu-item">
              <a class="site-footer-menu-link"
                 :href="item.url"
                 target="_blank"
                 :class="{'site-footer-menu-link--active': item.active}">{{ item.name }}</a>
            </div>
          </div>

          <template v-if="index + 1 === data.menu.length">
            <section class="site-footer-social site-footer-social--hidden-sm">
              <div class="site-footer-social-icons">
                <a :href="data.vkUrl"
                   target="_blank"
                   class="site-footer-social-link">
                  <img :src="data.vkLogoUrl"
                       alt=""
                       class="site-footer-social-icon">
                </a>
                <a :href="data.vcUrl"
                   target="_blank"
                   class="site-footer-social-link">
                  <img :src="data.vcLogoUrl"
                       alt=""
                       class="site-footer-social-icon">
                </a>
                <a :href="data.whatsappUrl"
                   target="_blank"
                   class="site-footer-social-link">
                  <img :src="data.whatsappLogoUrl"
                       alt=""
                       class="site-footer-social-icon">
                </a>
              </div>

              <div class="site-footer-social-qr">
                <img :src="data.mobileAppQRUrl" alt="">
                <div class="site-footer-social-qr-text site-footer-text--small" v-text="data.mobileAppQRText"></div>
              </div>
            </section>
          </template>
        </div>
      </section>

      <section class="site-footer-license site-footer-row--border">
        <div class="site-footer-license-fts">
          <img :src="data.ftsLogoUrl" alt="">
          <div v-text="data.ftsLogoText"
               class="site-footer-license-fts-text site-footer-text--small"></div>
        </div>

        <div class="site-footer-license-foundation site-footer-text--small">
          &copy; {{ data.companyName }}, {{ data.foundationYear }} - {{ data.currentYear }}.
          Все права защищены
        </div>

        <section class="site-footer-social site-footer-social--visible-sm">
          <div class="site-footer-social-icons">
            <a :href="data.vkUrl"
               target="_blank"
               class="site-footer-social-link">
              <img :src="data.vkLogoUrl"
                   alt=""
                   class="site-footer-social-icon">
            </a>
            <a :href="data.vcUrl"
               target="_blank"
               class="site-footer-social-link">
              <img :src="data.vcLogoUrl"
                   alt=""
                   class="site-footer-social-icon">
            </a>
            <a :href="data.whatsappUrl"
               target="_blank"
               class="site-footer-social-link">
              <img :src="data.whatsappLogoUrl"
                   alt=""
                   class="site-footer-social-icon">
            </a>
          </div>
        </section>
      </section>
      <section class="site-footer-policy site-footer-row--border">
        <div v-html="data.attentionText"
             class="site-footer-policy-text site-footer-text--small"></div>
      </section>
    </div>
  </div>
-->